var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"bg-[#F8F9F4] h-[200px] flex items-center justify-center text-2xl font-medium tracking-widest text-center"},[_vm._v("\n    在宅看護指導士"),_c('br'),_vm._v("\n    資格試験申し込みの確認\n")])
}]

export { render, staticRenderFns }